module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"media-manager <%= scheduleBadge ? 'media-live' : '' %> \">\n    <%  if (scheduleBadge){ %>\n        <% if (!isUpcoming) { %>\n            <div class=\"live-indicator event-pill\">\n                <span class=\"reddot\" <% if (navigator.userAgent.indexOf('Win') != -1) { %> style=\"margin-top: 0px\" <% } %> ></span>\n                <span class=\"live-icon-copy\" <% if (navigator.userAgent.indexOf('Win') != -1) { %> style=\"padding-bottom: 2px\" <% } %> ><%= liveCopy %></span>\n            </div>\n        <% } else { %>\n            <div class=\"live-indicator event-pill\">\n                <span class=\"live-icon-copy\" <% if (navigator.userAgent.indexOf('Win') != -1) { %> style=\"padding-bottom: 2px\" <% } %> ><%= scheduleBadgeText %></span>\n            </div>\n        <% } %>\n    <% } %>\n    <div class=\"media-manager-video\">\n        <% if (videoUrl !== \"\") { %>\n            <div id=\"<%=previewContainer%>\" class=\"video-preview\"></div>\n        <% } %>\n    </div>\n    <div class=\"media-manager-image\">\n        <img class=\"lazy delayed-load-image\" content=\"<%= imageUrl %>\" alt=\"<%= imageAlt %>\" />\n    </div>\n    <div class=\"media-gradient\"></div>\n     \n    <div class=\"media-info\">\n        <% if (videoLogoUrl !== \"\") { %>\n            <img class=\"media-logo\" src=\"<%= videoLogoUrl %>\" />\n        <% } else if(isLive || scheduleBadge) { %>\n            <p><%= channelName %></p>\n        <% } else { %>\n            <p><%= fallbackText %></p>\n        <% } %>\n        <% if (!CBS.Registry.region.international) { %>\n        <button class=\"sound-control\"></button>\n        <% } %>\n        <% if (isLive || scheduleBadge) { %>\n            <p><%= fallbackText %></p>\n        <% } %>\n    </div>\n</div>"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/carousels/highlightCarousel/mediaManager.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; __append("<div class=\"media-manager ")
    ; __append(escapeFn( scheduleBadge ? 'media-live' : '' ))
    ; __append(" \">\n    ")
    ; __line = 2
    ;   if (scheduleBadge){ 
    ; __append("\n        ")
    ; __line = 3
    ;  if (!isUpcoming) { 
    ; __append("\n            <div class=\"live-indicator event-pill\">\n                <span class=\"reddot\" ")
    ; __line = 5
    ;  if (navigator.userAgent.indexOf('Win') != -1) { 
    ; __append(" style=\"margin-top: 0px\" ")
    ;  } 
    ; __append(" ></span>\n                <span class=\"live-icon-copy\" ")
    ; __line = 6
    ;  if (navigator.userAgent.indexOf('Win') != -1) { 
    ; __append(" style=\"padding-bottom: 2px\" ")
    ;  } 
    ; __append(" >")
    ; __append(escapeFn( liveCopy ))
    ; __append("</span>\n            </div>\n        ")
    ; __line = 8
    ;  } else { 
    ; __append("\n            <div class=\"live-indicator event-pill\">\n                <span class=\"live-icon-copy\" ")
    ; __line = 10
    ;  if (navigator.userAgent.indexOf('Win') != -1) { 
    ; __append(" style=\"padding-bottom: 2px\" ")
    ;  } 
    ; __append(" >")
    ; __append(escapeFn( scheduleBadgeText ))
    ; __append("</span>\n            </div>\n        ")
    ; __line = 12
    ;  } 
    ; __append("\n    ")
    ; __line = 13
    ;  } 
    ; __append("\n    <div class=\"media-manager-video\">\n        ")
    ; __line = 15
    ;  if (videoUrl !== "") { 
    ; __append("\n            <div id=\"")
    ; __line = 16
    ; __append(escapeFn(previewContainer))
    ; __append("\" class=\"video-preview\"></div>\n        ")
    ; __line = 17
    ;  } 
    ; __append("\n    </div>\n    <div class=\"media-manager-image\">\n        <img class=\"lazy delayed-load-image\" content=\"")
    ; __line = 20
    ; __append(escapeFn( imageUrl ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( imageAlt ))
    ; __append("\" />\n    </div>\n    <div class=\"media-gradient\"></div>\n     \n    <div class=\"media-info\">\n        ")
    ; __line = 25
    ;  if (videoLogoUrl !== "") { 
    ; __append("\n            <img class=\"media-logo\" src=\"")
    ; __line = 26
    ; __append(escapeFn( videoLogoUrl ))
    ; __append("\" />\n        ")
    ; __line = 27
    ;  } else if(isLive || scheduleBadge) { 
    ; __append("\n            <p>")
    ; __line = 28
    ; __append(escapeFn( channelName ))
    ; __append("</p>\n        ")
    ; __line = 29
    ;  } else { 
    ; __append("\n            <p>")
    ; __line = 30
    ; __append(escapeFn( fallbackText ))
    ; __append("</p>\n        ")
    ; __line = 31
    ;  } 
    ; __append("\n        ")
    ; __line = 32
    ;  if (!CBS.Registry.region.international) { 
    ; __append("\n        <button class=\"sound-control\"></button>\n        ")
    ; __line = 34
    ;  } 
    ; __append("\n        ")
    ; __line = 35
    ;  if (isLive || scheduleBadge) { 
    ; __append("\n            <p>")
    ; __line = 36
    ; __append(escapeFn( fallbackText ))
    ; __append("</p>\n        ")
    ; __line = 37
    ;  } 
    ; __append("\n    </div>\n</div>")
    ; __line = 39
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/carousels/highlightCarousel/mediaManager.tpl"

}